<template>
  <div>

    <router-link
      :to="{name: 'master-customer-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Nama"
                label-for="f-cust-id"
              >
                <v-select
                  id="f-cust-id"
                  v-model="cust_id"
                  :options="custOpt"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                />
              </b-form-group>
            </b-col>
            <!-- KAS NAME -->
            <b-col md="6">
              <b-form-group
                label="Kas & Bank"
                label-for="cash_id"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kas & Bank"
                  rules="required"
                >
                  <v-select
                    id="cash_id"
                    v-model="cash_id"
                    :options="cashOpt"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    label="title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- IN OUT -->
            <b-col md="6">
              <b-form-group
                label="In/Out"
                label-for="in_out"
              >
                <validation-provider
                  #default="{ errors }"
                  name="In/Out"
                  rules="required"
                >
                  <v-select
                    id="in_out"
                    v-model="in_out"
                    :options="InOutOpt"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    label="title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- JUMLAH -->
            <b-col md="6">
              <b-form-group
                label="Jumlah"
                label-for="amount"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jumlah"
                  rules="required"
                >
                  <cleave
                    id="amount"
                    v-model="amount"
                    class="form-control"
                    placeholder="Masukan Jumlah"
                    :raw="false"
                    :options="options.number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <!-- Tombol Aksi -->
            <b-col
              md="8"
              class="justifyfy-content-center"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
    vSelect,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      cash_id: null,
      in_out: null,
      amount: null,
      cashOpt: [],
      custOpt: [],
      coaOpt: [],
      InOutOpt: [
        { value: '1', title: 'In' },
        { value: '2', title: 'Out' },
      ],
      required,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true,
        },
      },
    }
  },
  computed: {},
  created() {
    this.$http.get('/cashmaster').then(res => {
      this.cashOpt = res.data.data.map(cash => ({
        value: cash.id,
        title: cash.name,
      }))
    })

    // GET CASH OPTION
    this.$http.get('/customer')
      .then(res => {
        this.custOpt = res.data.data.data.map(cust => ({
          value: cust.id,
          title: cust.name,
        }))
      })
  },
  mounted() {
  },
  methods: {
    submitProduct() {
      const payload = {
        cash_id: this.cash_id.value,
        cust_id: this.cust_id.value,
        in_out: this.in_out.value,
        nominal: this.amount.replace(/[^0-9]/g, ''),
      }

      console.log(payload)

      this.$http.post('/depo-history/add', payload)
        .then(() => {
          this.$bvToast.toast('Deposit Pelanggan berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'master-customer-list' })
        })
        .catch(err => {
          console.error(err.response?.status)
          const message = err.response?.data?.message || 'Terjadi kesalahan saat menambahkan Deposit Pelanggan!'
          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitProduct()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
